module.exports = __webpack_public_path__ + "img/settingLogout.083959bb.svg";